import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Input, Spin } from "antd"; 
import attendanceTemplate from "../../../assets/temp/upload attendance summary.xlsx";
import InsideHeader from "../../../components/InsideHeader";
import download from "../../../assets/svg/file_download-24px.svg";
import upload from "../../../assets/svg/file_upload-24px.svg";  
import AttendanceSummaryModal from "./modal/AttendanceSummaryModal";

const url = process.env.REACT_APP_API_BASE_URL;

export default function AttendanceSummary() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const linkRef = useRef(null);
 
  const [downloaded, setDownloaded] = useState(false);

 
  const handleClick = async (event) => {
  
  };
  const [openExcelUpload, setopenExcelUpload] = useState(false);
  function handleCancelExcelUpload() {
    setopenExcelUpload(false);
  }
 
  return (
    <div className="w-full overflow-y-scroll">
      <InsideHeader
        title="Attendance Summary Entries"
        subtitle="Upload bulk attendance summary entries"
        back={true}
        title1="Attendance Summary Entries List"
        title2="Attendance Summary Upload"
      />

      <div className="px-10 mt-[51px]">
        <span className="text-black1  text-[24px] font-bold dash-title leading-[32.4px]">
          Import list of attendance summary entries (excel file)
        </span>

        <div
          className="mt-[31px] bg-white flex flex-col justify-center items-center border bottom-solid border-[#F5F7FF]
		w-[912px] h-[306px] px-0 py-[60px]"
        >
          {downloaded ? (
            <>
              <div className="text-black1 text-[18px] font-normal font-dmSans leading-[24px]">
                You have downloaded the template
              </div>
              <div className="mt-[10px] text-[#616161] text-[16px] font-normal leading-[24px]">
                Fill in the template with the list of attendace entries and upload it
                when you are done
              </div>
              <div className="flex flex-col mt-[20px]">
                <a
                  className="cursor-pointer w-[250px] h-[50px] px-[24px] py-3 bg-blueDark rounded-[28px] justify-center items-center gap-1 inline-flex
			          	text-white text-[16px] font-medium "
                  download
                  onClick={() => setopenExcelUpload(true)}
                >
                  <img src={upload} alt="upload-icon" />
                  Upload template
                </a>
                <a
                  className="mt-[10px] w-[250px] h-[50px] px-[24px] py-3 border-none text-darkBlue rounded-[28px] justify-center items-center gap-1 inline-flex
				        text-[16px] font-medium "
                  href={attendanceTemplate}
                  download
                  onClick={() => setDownloaded(true)}
                >
                  <img src={download} alt="download-icon" />
                  Re-download template
                </a>
              </div>
            </>
          ) : (
            <>
              <div className="text-black1 text-[18px] font-normal font-dmSans leading-[24px]">
                Complete the following steps to import your list of attendance
              </div>

              <div className="mt-[10px] text-[#616161] text-[16px] font-normal leading-[24px]">
                Step 1. Download the excel template by clicking the button
                below.
                <br />
                Step 2. Fill in the template with the list of attendance.
                <br />
                Step 3. Upload the filled in template.
              </div>

              <div className="flex flex-col mt-[20px] justify-center items-center">
              <a
                 ref={linkRef}
                  className="w-[200px] cstm-btn"
                  href={attendanceTemplate}
                  download 
                  onClick={(e) => e.stopPropagation()}
                >
                  <span className="flex items-center gap-x-[4px]" onClick={handleClick}>
                  <img src={download} alt="download-icon" />
                  Download template
                  </span>
                </a>

                <div
                  className="mt-[10px] w-full h-[50px] px-[24px] py-3 border-none text-darkBlue rounded-[28px] justify-center items-center gap-1 inline-flex
				              text-[16px] font-medium cursor-pointer"
                  onClick={() => setopenExcelUpload(true)}
                >
                  Already have template ? Proceed to upload
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <AttendanceSummaryModal
        open={openExcelUpload}
        handleCancelModal={handleCancelExcelUpload}
      />
    </div>
  );
}
